import { render, staticRenderFns } from "./OfferDetailPage.vue?vue&type=template&id=8ea0fe28&"
import script from "./OfferDetailPage.vue?vue&type=script&lang=js&"
export * from "./OfferDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ea0fe28')) {
      api.createRecord('8ea0fe28', component.options)
    } else {
      api.reload('8ea0fe28', component.options)
    }
    module.hot.accept("./OfferDetailPage.vue?vue&type=template&id=8ea0fe28&", function () {
      api.rerender('8ea0fe28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/offerdetails/OfferDetailPage.vue"
export default component.exports